import Marquee from "react-fast-marquee";

const ITEMS = [
    "Kaca Aluminium",
    "Desain Interior",
    "Fasad",
    "Partisi Kaca",
    "Kanopi",
    "Shower Glass",
    "Kitchen Set",
    "Folding Door",
];

export default function Ribbon() {
    return (
        <div className="border-y border-white/10 bg-surface/70 py-6 lg:py-9">
            <Marquee speed={38} gradient={false} direction="left">
                <div className="flex items-center">
                    {ITEMS.map((item, i) => (
                        <span key={item} className="flex items-center">
                            <span
                                className={`whitespace-nowrap font-serif text-3xl lg:text-5xl ${
                                    i % 2 === 1
                                        ? "italic text-gold/90"
                                        : "text-zinc-200"
                                }`}
                            >
                                {item}
                            </span>
                            <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-gold/60 lg:mx-16" />
                        </span>
                    ))}
                </div>
            </Marquee>
        </div>
    );
}
